import { Flex, Text } from '@chakra-ui/react';
import { Badge, Modal } from '@morressier/alembic';
import { ReactNode } from 'react';

interface Props {
  onClose: () => void;
  children: ReactNode;
}

interface DiffSideProps {
  children: ReactNode;
  label: string;
}

export const DiffModal = ({ onClose, children }: Props) => {
  return (
    <Modal
      isOpen
      onClose={onClose}
      width="1280px"
    >
      <Flex
        padding={8}
        flexDirection="column"
        gap={4}
        height="720px"
        overflow={'auto'}
        backgroundColor="surfaceSecondaryFill"
      >
        <Text textStyle="headingOverline" textTransform="uppercase">
          Recent Updates
        </Text>
        <Flex gap={4}>{children}</Flex>
      </Flex>
    </Modal>
  );
};

DiffModal.LeftSide = ({ children, label }: DiffSideProps) => {
  return (
    <Flex flexDirection="column" width="50%" gap={2}>
      <Flex gap={2} alignItems="center">
        <Text textStyle="headingGroup" textTransform={'capitalize'}>
          {label}
        </Text>
        <Badge variant="neutral" size="context">
          Previous
        </Badge>
      </Flex>
      {children}
    </Flex>
  );
};

DiffModal.RightSide = ({ children, label }: DiffSideProps) => {
  return (
    <Flex flexDirection="column" width="50%" gap={2}>
      <Flex gap={2} alignItems="center">
        <Text textStyle="headingGroup" textTransform={'capitalize'}>
          {label}
        </Text>
        <Badge variant="attention" size="context">
          Current
        </Badge>
      </Flex>
      {children}
    </Flex>
  );
};
